import { sortTypeEnum } from '@/constants/global';
const state = {
    filterOption: {
        shareInfoStatusType: '',
        searchWord: {
            value: '',
            condition: 'like',
        },
    },
    shareInfo: null,
    shareStoreList: [],
    selectedRowShareInfo: null,
    // 현재는 sort field가 수주 허브명 한 곳뿐이나 추후 확장 가능성을 고려하여 복수형으로 남김
    shareInfoSortOptions: [
        {
            field: 'hubName',
            value: sortTypeEnum.ASC,
        },
    ],
};
export default state;
